module.exports = __webpack_public_path__ + "static/img/tx001.1f21c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx001.png
// module id = 8Mn+
// module chunks = 1